/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {pageVisitsServiceInitializerfactory as ɵd} from './page-visits/page-visits.initializer';
export {PageVisitsService as ɵc} from './page-visits/page-visits.service';
export {RecommendedPageService as ɵb} from './recommended-pages/recommended-page.service';
export {UserRoleRecommendedPageService as ɵa} from './recommended-pages/user-role-recommended-page.service';